import Vue from 'vue'
import LoadingComponent from './index.vue'

const Loading = {}
let loadingNode = null

Loading.install = function (Vue) {
  const LoadingConstructor = Vue.extend(LoadingComponent)
  if (loadingNode) return;
  loadingNode = new LoadingConstructor()
  loadingNode.$mount()
  document.body.appendChild(loadingNode.$el)

  Vue.prototype.$loading = {
    show: function(mask){
      loadingNode.visible = true
      loadingNode.maskVisible = mask == false?mask:loadingNode.maskVisible
    },
    hide: function(){
      loadingNode.visible = false
    }
  }
}

export default Loading




// WEBPACK FOOTER //
// ./src/components/common-components/features/loading/index.js